<template>
  <div class="section desc-1 mt-3" id="crm-sect">
    <div class="container">
      <div class="row align-items-center" data-aos="fade-up">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <h3 class="title">CRM <span class="font-bold">Engine</span></h3>
            </div>
            <div class="col-12">
              <span class="sub-text text-center mb-lg-0 mb-5"
                >A dedicated solution for <b>Game Providers</b>. Designing Games
                is your <strong>business - add-on Marketing Tools</strong> is
                ours!<br /><b>The Ear CRM Engine</b> provides you with a
                comprehensive marketing tool designed for content providers (<b
                  >Slot Games, Live Games, Instant, Lottery, Bingo, including
                  Sportsbook etc</b
                >). All the marketing tools you need to have an edge in the
                marketplace and provide your clients with the best in business
                marketing features on your games, all available in a simple
                <strong>API integration</strong>.<br />Design automated
                customized <b>tournaments</b>, with basic point accumulation on
                <b>bets/win/net</b> or give players a chance to accumulate extra
                point by using the custom ranking option, tournaments come with
                <b>API leaderboards feed</b>, so you can design the leaderboard
                however you want in the front-end.</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="wrapper-multiple-items row multiple-items mt-5">
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="100">
          <div class="bro-card-orange">
            <p>Login Bonus</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="200">
          <div class="bro-card-orange">
            <p>Registration Bonus</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="300">
          <div class="bro-card-orange">
            <p>Deposit Bonus</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="400">
          <div class="bro-card-orange">
            <p>
              Welcome Package<br /><small style="text-transform: initial"
                >(First 5 Deposit)</small
              >
            </p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="500">
          <div class="bro-card-orange">
            <p>Cash back feature</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="600">
          <div class="bro-card-orange">
            <p>Bonus safety Trigers</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="700">
          <div class="bro-card-orange">
            <p>Automated Happy Hour</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="800">
          <div class="bro-card-orange">
            <p>Birthday bonuses</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="900">
          <div class="bro-card-orange">
            <p>Segmentation tools</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1000">
          <div class="bro-card-orange">
            <p>In-game pop-up notification customizable</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1100">
          <div class="bro-card-orange">
            <p>Tournaments with custom parameters</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1200">
          <div class="bro-card-orange">
            <p>Campaign analytics reports</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1300">
          <div class="bro-card-orange">
            <p>Free spin engine on any type of game</p>
          </div>
        </div>
        <div class="col col-card" data-aos="zoom-in" data-aos-delay="1400">
          <div class="bro-card-orange">
            <p>Campaign management</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.section {
  padding: 90px 15px 0px 15px;
}

.aggregator-branded-container {
  padding-top: 100px;
}

.section .title {
  text-align: center;
  font-weight: 700;
  font-size: 25px;
  line-height: 1.44;
  color: #25354d;
  margin: 0px 0px 20px 0px;
  font-family: "Montserrat", sans-serif;
}
.section .card {
  text-align: center;
  background: transparent;
  border: 0;
  transition: all 0.4s ease;
}
.section .card .card-img-top {
  transition: all 0.4s ease;
  max-width: 250px;
}
.section .card a {
  color: inherit;
}
.section .card .card-body {
  border: 1px solid transparent;
  margin-top: 1rem;
  transition: all 0.4s ease;
  border-radius: 10px;
}
.section .card .card-body .card-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.section .card:hover .card-body {
  color: #1976d2;
}

.section.desc-1 .title {
  text-align: center;
  font-weight: 700;
  font-size: 25px;
  line-height: 1.44;
  margin-bottom: 15px;
  color: #25354d;
  font-family: "Montserrat", sans-serif;
}
.section.desc-1 .sub-text {
  text-align: center;
  line-height: 1.75;
  font-size: 17px;
  margin-top: 20px !important;
  font-weight: 500;
}
.section.desc-1 .vacancy-cnt {
  color: white;
}
.section.desc-1 .vacancy-cnt .title {
  color: #2196f3;
  transition: all 0.4s ease;
}
.section.desc-1 .vacancy-cnt:hover .title {
  color: #ff5722;
}
.section.desc-1 .multiple-items {
  justify-content: left;
}
.section.desc-1 .multiple-items .col-card {
  flex: 0 0 25%;
  margin-bottom: 1.5rem;
}

.bro-card:hover {
  border-color: #ff5722 !important;
  color: #fff;
  background: #ff5722 !important;
}

@media (max-width: 992px) {
  .section.desc-1 .multiple-items .col-card {
    flex: 0 0 33.3%;
  }
}

@media (max-width: 768px) {
  .bro-card-orange p {
    font-size: 12px !important;
    text-transform: uppercase;
    margin-bottom: 0px !important;
  }

  .section {
    padding: 40px 15px 0px 15px;
  }
}

@media (max-width: 576px) {
  .section.desc-1 .multiple-items .col-card {
    flex: 0 0 50%;
  }
}
.section.desc-1 .multiple-items .col-card .bro-card-orange {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 300px;
  height: 100%;
  background: #e66640;
  color: #fff;
  padding: 8px 20px;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  border-radius: 999px;
  height: 60px;
}

.bro-card-orange:hover {
  border-color: #ff5722 !important;
  color: #fff;
  background: #ff5722 !important;
}

.bro-card-orange p {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin-bottom: 0px !important;
  font-family: "Montserrat", sans-serif;
  letter-spacing: -0.05em;
  scale: 0.95;

    @media (max-width: 767px) {
    zoom: 85%;
    line-height: 1.4;
  }
}

.section.desc-1 .multiple-items .col-card .bro-card .img-fluid {
  max-height: 55px;
}
.section.desc-1 .multiple-items .col-card .bro-card-orange {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 300px;
  height: 60px;
  background: #e66640;
  color: #fff;
  padding: 1rem 1rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  border-radius: 999px;
}

.wrapper-multiple-items {
  padding-top: 60px;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
